// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage, ref, getDownloadURL, listAll } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// const firebaseApiKey = process.env.VITE_FIREBASE_API_KEY;
const firebaseApiKey = import.meta.env.VITE_FIREBASE_API_KEY //was failing env stuff please help!

// Debug logging
console.log('Environment Variables:', {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
});

//console.log("firebase api Key is: " + firebaseApiKey)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};


// Add console.log here
console.log('Firebase config loaded:', {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY?.slice(0, 5) + '...',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

//analytics & database ssetup
const analytics = getAnalytics(app);
const db = getFirestore(app);

//Authentication setup
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()


const storage = getStorage();
const getImageUrl = async (imagePath) => {
  const imageRef = ref(storage, imagePath);
  return await getDownloadURL(imageRef);
};

/**
 * Lists all image files in a Firebase Storage folder and returns their download URLs.
 * @param {string} folderPath - Path to folder (e.g. 'images/AdinkraWorld')
 * @returns {Promise<string[]>} Array of download URLs
 */
const getImagesFromFolder = async (folderPath) => {
  const folderRef = ref(storage, folderPath);
  const result = await listAll(folderRef);
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
  const urls = await Promise.all(
    result.items
      .filter((item) => {
        const name = item.name.toLowerCase();
        return imageExtensions.some((ext) => name.endsWith(`.${ext}`) || name.endsWith(ext));
      })
      .map(async (itemRef) => getDownloadURL(itemRef))
  );
  return urls;
};

export { db, auth, googleProvider, storage, getImageUrl, getImagesFromFolder };